import { useState } from 'react';

export const useForgotPassword = () => {
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const forgotPassword = async (email, ref, language) => {
    setIsLoading(true);
    setError(null);
    setMessage(null);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/user/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, ref, language }),
      });

      const json = await response.json();

      if (!response.ok) {
        setError(json.error || 'Er is iets misgegaan.');
        setIsLoading(false);
        return false;
      }

      setMessage(json.message);
      setIsLoading(false);
      return true;
    } catch (err) {
      setError('Er is iets misgegaan. Probeer het opnieuw.');
      setIsLoading(false);
      return false;
    }
  };

  return { forgotPassword, isLoading, error, message };
};